module.exports = __webpack_public_path__ + "img/TRAINTN_APPROVED.82186418.svg";